export default __webpack_public_path__ + "8504fccc6c2edef19c2dac54ecffd1e6.png";